const { createConstant } = require('../../helpers');

const service = 'market';

module.exports = {
  GET_CATEGORY: createConstant(service, 'GET_CATEGORY'),
  GET_CATEGORY_SUCCESS: createConstant(service, 'GET_CATEGORY_SUCCESS'),
  GET_CATEGORY_ERROR: createConstant(service, 'GET_CATEGORY_ERROR'),
  GET_CATEGORY_RESET: createConstant(service, 'GET_CATEGORY_RESET'),


  GET_SUB_CATEGORY: createConstant(service, 'GET_SUB_CATEGORY'),
  GET_SUB_CATEGORY_SUCCESS: createConstant(service, 'GET_SUB_CATEGORY_SUCCESS'),
  GET_SUB_CATEGORY_ERROR: createConstant(service, 'GET_SUB_CATEGORY_ERROR'),
  GET_SUB_CATEGORY_RESET: createConstant(service, 'GET_SUB_CATEGORY_RESET'),

  GET_CATEGORY_PRODUCTS: createConstant(service, 'GET_CATEGORY_PRODUCTS'),
  GET_CATEGORY_PRODUCTS_SUCCESS: createConstant(service, 'GET_CATEGORY_PRODUCTS_SUCCESS'),
  GET_CATEGORY_PRODUCTS_ERROR: createConstant(service, 'GET_CATEGORY_PRODUCTS_ERROR'),
  GET_CATEGORY_PRODUCTS_RESET: createConstant(service, 'GET_CATEGORY_PRODUCTS_RESET'),
};
